module.exports = __webpack_public_path__ + "img/03.8922026e.jpg";